import { CompetitionId, UserId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export interface ApplicationItem {
    competition_id: CompetitionId;
    user_id: UserId;
    application_id: string;
    update_at: number;
    application_name: string;
    application_url: string;
    user_firstname: string;
    user_lastname: string;
}

export function CompetitionApplicationsSource(competition_id: CompetitionId) {
    return new StreamSource<ApplicationItem[]>(`/applications/${competition_id}`);
}

export function CompetitionUserApplicationsSource(competition_id: CompetitionId, user_id: UserId) {
    return new StreamSource<ApplicationItem[]>(`/applications/${competition_id}/${user_id}`);
}